
export default function DepositGuide() {
  const steps = [
    {
      icon: 'ri-file-text-line',
      title: 'お申込',
      description: 'Webから簡単にお申込み',
    },
    {
      icon: 'ri-checkbox-circle-line',
      title: '審査・カード発行',
      description: '審査後、カードを発行',
    },
    {
      icon: 'ri-mail-line',
      title: 'カードお受取り',
      description: 'ご自宅にカードが届きます',
    },
    {
      icon: 'ri-bank-line',
      title: 'デポジット支払い',
      description: '指定口座へデポジットを入金',
    },
    {
      icon: 'ri-shopping-cart-line',
      title: 'カード利用',
      description: 'デポジット入金後、利用開始',
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#003366] mb-3 text-center">
          お申込の流れ
        </h2>
        <p className="text-gray-600 text-center mb-12">デポジット入金後、すぐにカードが使えます</p>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 mb-12">
          {steps.map((step, index) => (
            <div key={index} className="flex flex-col items-center text-center flex-1">
              <div className="w-16 h-16 flex items-center justify-center bg-[#0099CC] rounded-full mb-3">
                <i className={`${step.icon} text-white text-2xl`}></i>
              </div>
              <p className="text-[#003366] font-bold text-sm mb-1">{step.title}</p>
              <p className="text-gray-600 text-xs">{step.description}</p>
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute">
                  <i className="ri-arrow-right-line text-gray-300 text-2xl"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="bg-[#F8F9FA] rounded-xl p-6 md:p-8">
          <h3 className="text-lg font-bold text-[#003366] mb-6 text-center">
            デポジット型クレジットカードとは？
          </h3>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-white rounded-lg p-5 shadow-sm">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 flex items-center justify-center bg-[#E3F2FD] rounded-full">
                  <i className="ri-question-line text-[#0099CC] text-lg"></i>
                </div>
                <h4 className="font-bold text-[#003366]">デポジットとは？</h4>
              </div>
              <p className="text-gray-700 text-sm leading-relaxed">
                お客様の信用を補完するために担保としてお預かりするお金です。デポジットはお支払いにはご利用いただけません。脱会時に所定の方法で返金されます。
              </p>
            </div>
            <div className="bg-white rounded-lg p-5 shadow-sm">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 flex items-center justify-center bg-[#E3F2FD] rounded-full">
                  <i className="ri-exchange-line text-[#0099CC] text-lg"></i>
                </div>
                <h4 className="font-bold text-[#003366]">プリペイドカードとの違い</h4>
              </div>
              <p className="text-gray-700 text-sm leading-relaxed">
                プリペイドカードと違って、デポジットは預けたままで、カード利用代金を後払いでお支払いいただきます。クレジットカードとしての利用実績を積むことができます。
              </p>
            </div>
          </div>

          <div className="mt-6 bg-white rounded-lg p-5 shadow-sm">
            <h4 className="font-bold text-[#003366] mb-4">デポジットと利用限度額</h4>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div className="text-center p-3 bg-[#E3F2FD] rounded-lg">
                <p className="text-xs text-gray-600 mb-1">最低デポジット</p>
                <p className="text-lg font-bold text-[#003366]">5万円</p>
              </div>
              <div className="text-center p-3 bg-[#E3F2FD] rounded-lg">
                <p className="text-xs text-gray-600 mb-1">最高デポジット</p>
                <p className="text-lg font-bold text-[#003366]">200万円</p>
              </div>
              <div className="text-center p-3 bg-[#E3F2FD] rounded-lg">
                <p className="text-xs text-gray-600 mb-1">ETCカード条件</p>
                <p className="text-lg font-bold text-[#003366]">10万円以上</p>
              </div>
              <div className="text-center p-3 bg-[#E3F2FD] rounded-lg">
                <p className="text-xs text-gray-600 mb-1">増額申請</p>
                <p className="text-lg font-bold text-[#003366]">1万円単位</p>
              </div>
            </div>
            <p className="text-gray-600 text-xs mt-4 text-center">
              ※デポジットと同額がカードのご利用限度額となります
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
